import classNames from 'classnames';
import { DynamicImage, enLoading } from 'components/Image';
import { ScommessaAvvenimentoLink } from 'components/scommessaAvvenimentoLink';
import { ScommesseTableShowMore } from 'components/scommesseTable/scommesseTableShowMore';
import { useInfoTipo } from 'features/sport/hooks';
import { useTranslation } from 'hooks/useLingUI';
import useWindowSize from 'hooks/useWindowSize';
import { VisualizationEnum } from 'lib/api/sport/sportScommesseBySlugResponse';
import React, { memo, useMemo } from 'react';
import { ItemWithTranslation, SportsCompetitor } from 'types/swagger';
import { isNotEmpty } from 'utility/functions';
import { ScommesseTableAvvenimento as SnaiScommesseTableAvvenimento } from '../scommesseTableAvvenimento';
import styles from './ScommesseTableRow.module.scss';

export type ScommesseTableRowProps = ItemWithTranslation<{ title?: string; gruppo?: string }> & {
  // data?: string;
  // ora: string;
  live?: boolean;
  widget?: {
    id: string;
    url?: string;
    action?: () => void;
  }[];
  competitors: Array<SportsCompetitor>;
  urlAvvenimento: string;
  providerID?: number;
  viewAllItemsNumber?: number;
  children?: React.ReactNode;
  hasMultipleLines?: boolean;
  hasHeader?: boolean;
  hasBorderSide?: boolean;
  disableWidget?: boolean;
  className?: string;
  timestamp?: string;
  classNameTitle?: string;
  avvenimentoKey?: string;
  isEstesa?: boolean;
  iconSrc?: string;
  testId?: string;
  infoTipoScommessaKey?: string | undefined;
  showOnlyHours?: boolean;
};

export const ScommesseTableRow = memo(function ScommesseTableRow({
  live,
  title,
  testId,
  gruppo,
  widget,
  iconSrc,
  children,
  isEstesa,
  className,
  // hasHeader,
  titleTrKey,
  providerID,
  gruppoTrKey,
  competitors,
  hasBorderSide,
  disableWidget,
  showOnlyHours,
  avvenimentoKey,
  urlAvvenimento,
  classNameTitle,
  hasMultipleLines,
  viewAllItemsNumber,
  infoTipoScommessaKey,
}: ScommesseTableRowProps) {
  const { t } = useTranslation();
  const { isMobile } = useWindowSize();
  const infoTipoScommessa = useInfoTipo(infoTipoScommessaKey);

  const isVertical = useMemo(() => {
    switch (infoTipoScommessa?.tipoVisualizzazione) {
      case VisualizationEnum.EsitiUnderThree:
      case VisualizationEnum.EsitiOverThree:
      case VisualizationEnum.SingleInfoAggEsitiUnderThree:
      case VisualizationEnum.SingleInfoAggEsitiOverThree:
        return false;
      default:
        return true;
    }
  }, [infoTipoScommessa]);

  return (
    <div
      data-testid={testId}
      suppressHydrationWarning
      className={classNames(styles.container, className ?? '', {
        [styles.isEstesa]: isEstesa,
        // [styles.first]: hasHeader,
      })}
    >
      {title && (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <React.Fragment>
          <span
            className={classNames(styles.title, classNameTitle, {
              [styles.withIcon]: isNotEmpty(iconSrc),
              [styles.isEstesa]: isEstesa,
              [styles.hidden]: isMobile,
            })}
          >
            {isNotEmpty(iconSrc) && (
              <DynamicImage
                src={`${iconSrc}`}
                width={16}
                height={16}
                alt="Scommesse"
                layout={'fixed'}
                loading={enLoading.lazy}
                className={styles.icon}
              />
            )}
            {gruppo && `${t(gruppoTrKey, gruppo)} - `}
            {t(titleTrKey, title)}
          </span>
        </React.Fragment>
      )}
      <SnaiScommesseTableAvvenimento
        widget={widget}
        className={classNames(styles.avvenimento, { [styles.avvenimentoLive]: live })}
        providerID={disableWidget ? undefined : providerID}
        competitors={competitors}
        hasBorderTop={hasBorderSide}
        disableWidget={disableWidget}
        hasBorderSide={hasBorderSide}
        avvenimentoKey={avvenimentoKey}
        urlAvvenimento={urlAvvenimento}
        hasMultipleLines={hasMultipleLines}
        results={viewAllItemsNumber}
        showOnlyHours={showOnlyHours}
      />
      <div className={classNames(styles.column, { [styles.isEstesa]: isEstesa })}>{children}</div>
      {(disableWidget === false || disableWidget === undefined) && (
        <ScommessaAvvenimentoLink
          className={classNames(
            styles.showMore,
            { [styles.hidden]: isMobile },
            hasBorderSide ? styles.borderRight : ''
          )}
          avvenimentoKey={avvenimentoKey}
        >
          <ScommesseTableShowMore results={viewAllItemsNumber} className={classNames(styles.showMoreBtn)} />
        </ScommessaAvvenimentoLink>
      )}
    </div>
  );
});
